import React from "react";
import "./uploader.scss";
import { Icon } from "@iconify/react";
import {
  loadMessages,
} from "@progress/kendo-react-intl";

import bgMessages from "./bg.json";
loadMessages(bgMessages, "bg-BG");

interface Props {
  batch?: boolean;
  multiple?: boolean;
  defaultFiles?: any;
  withCredentials?: boolean;
  saveUrl?: string;
  removeUrl?: string;
  onAdd?: any;
  uploadFile?: any;
  upload?: any;
  error?: boolean;
  message?: string;
  resume?: string | null;
}

const UploadFiled: React.FC<Props> = ({
  batch,
  multiple,
  defaultFiles,
  saveUrl,
  withCredentials,
  removeUrl,
  onAdd,
  uploadFile,
  upload,
  error,
  message,
  resume,
  ...rest
}) => {
    
   
  return (
    <div className="uploader">
      <div className="k-dropzone">
        {!resume ? (
          <div className="k-upload-button">
            <input
              type="file"
              id="img"
              name="img"
              accept=".pdf,.doc,.docx"
              onChange={(e) => uploadFile(e)}
            />
            Choose File
          </div>
        ) : (
          <div>
            <div className="d-flex-wrap">
              <div className="greenIcon">
                <Icon icon="bi:file-earmark-check-fill" />
              </div>{" "}
              {resume}
            </div>
            <div className="re-upload">
              <input
                type="file"
                id="img"
                name="img"
                accept=".pdf,.doc,.docx"
                onChange={(e) => uploadFile(e)}
              />
              Update Resume
            </div>
          </div>
        )}
        {upload && !error && (
          <div className="k-dropzone-hint success">{message}</div>
        )}
        {!upload && !error && (
          <div className="k-dropzone-hint success">{message}</div>
        )}
        {error && <div className="k-dropzone-hint error">{message}</div>}
      </div>
    </div>
  );
};

export default UploadFiled;
